const HomeBtn = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Icons'>
        <path
          id='Home'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M19.7557 9.41066L10.589 0.243989C10.2636 -0.0813296 9.7361 -0.0813296 9.41068 0.243989L0.244013 9.41066C0.00575645 9.64898 -0.0655052 10.0074 0.0634481 10.3187C0.192401 10.63 0.496183 10.8331 0.83318 10.8332H1.87485C1.98991 10.8332 2.08318 10.9264 2.08318 11.0415V19.1665C2.08318 19.6267 2.45628 19.9998 2.91651 19.9998H7.70818C7.82324 19.9998 7.91651 19.9065 7.91651 19.7915V15.8332C7.91651 14.6826 8.84925 13.7498 9.99985 13.7498C11.1504 13.7498 12.0832 14.6826 12.0832 15.8332V19.7915C12.0832 19.9065 12.1765 19.9998 12.2915 19.9998H17.0832C17.5434 19.9998 17.9165 19.6267 17.9165 19.1665V11.0415C17.9165 10.9264 18.0098 10.8332 18.1248 10.8332H19.1665C19.5035 10.8331 19.8073 10.63 19.9362 10.3187C20.0652 10.0074 19.9939 9.64898 19.7557 9.41066Z'
          fill='#1D1D1B'
        />
      </g>
    </svg>
  );
};

export default HomeBtn;
